import { Element as CraftElement, useEditor, useNode } from "@craftjs/core";
import * as React from "react";

export const defaultElementProps = {
  is: "div",
  canvas: false,
  custom: {},
  hidden: false,
};

/**
 * @deprecated Fixed with media queries; with the introduction of
 * https://github.com/prevwong/craft.js/pull/245, updated props
 * are not applied to `Element`. This is intended, but breaks our
 * current implementation when updating styles.
 */
export default function Element<T extends React.ElementType>({
  id,
  children,
  ...elementProps
}: CraftElement<T>) {
  const { query, actions } = useEditor();
  const node = useNode((node) => ({
    id: node.id,
    data: node.data,
    linkedNodes: node.getLinkedNodes(),
  }));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { is, custom, canvas, ...otherProps } = {
    ...defaultElementProps,
    ...elementProps,
  };

  React.useEffect(() => {
    if (node.inNodeContext) {
      const existingNode =
        node.linkedNodes &&
        node.linkedNodes[id] &&
        query.node(node.linkedNodes[id].id).get();

      if (existingNode && existingNode.data.type === is) {
        const mergedProps = {
          ...existingNode.data.props,
          ...otherProps,
        };

        actions.history
          .ignore()
          .setProp(existingNode.id, (props) =>
            Object.keys(mergedProps).forEach(
              (key) => (props[key] = mergedProps[key])
            )
          );
      }
    }
    // actions.history & query are unstable and don't need to be here
    // eslint-disable-next-line
  }, [id, is, node.id, node.inNodeContext, otherProps]);

  return (
    <CraftElement id={id} {...elementProps}>
      {children}
    </CraftElement>
  );
}
